<template>
  <div class="customer-list c:col-start-stretch">
    <CEmpty v-if="list.length == 0 && !loading" text="暂无顾客" />
    <div class="filter-bar">
      <CSearchBar
        v-model="keyword"
        placeholder="搜索客人昵称"
        @search="onSearch"
        @clear="onClear"
      />
    </div>
    <div class="customer-list-wrapper">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="list.length > 0 ? '' : ''"
        @load="load"
      >
        <customer-list-cell
          :data="item"
          v-for="(item, index) in list"
          :key="index"
          :title="item"
        />
      </van-list>
      <CBottomPad is-tab-page />
    </div>
  </div>
</template>
<script>
import { getCustomersList } from "@/api";
import CEmpty from "@/components/common/Empty.vue";
import CustomerListCell from "@/components/customer/CustomerListCell.vue";
import CSearchBar from "@/components/common/SearchBar.vue";
import { USER_ROLES } from "@/consts";
import CBottomPad from "../common/CBottomPad.vue";
export default {
  components: {
    CEmpty,
    CustomerListCell,
    CSearchBar,
    CBottomPad,
  },
  props: {
    role: String,
  },
  data() {
    return {
      keyword: "",
      list: [],
      page: 1,
      loading: false,
      finished: false,
      refreshing: false,
    };
  },
  computed: {
    storeId() {
      if (this.role === USER_ROLES.STORE_MANAGER) {
        return this.$store.getters.currentStore?.storeId || undefined;
      }
      return undefined;
    },
  },
  methods: {
    async load() {
      try {
        if (this.refreshing) {
          this.page = 1;
          this.list = [];
          this.refreshing = false;
        }
        const res = await getCustomersList({
          pageNum: this.page || 1,
          pageSize: 10,
          keyword: this.keyword,
          storeId: this.storeId,
        });
        console.log("getCustomersList", res);
        res.data?.forEach((element) => {
          this.list.push(element);
        });
        this.page++;
        this.loading = false;
        this.finished = !res.hasMore;
      } catch (error) {
        this.loading = false;
        this.finished = true;
      }
    },
    reload() {
      this.loading = true;
      this.finished = false;
      this.refreshing = true;
      this.load();
    },
    onSearch() {
      // console.error("onSearch", this.keyword);
      this.reload();
    },
    onClear() {
      console.error("onClear", this.keyword);
      this.reload();
    },
  },
};
</script>
<style lang="less" scoped>
.customer-list {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
  border-top: solid 2px #f2f2f2;
  user-select: none;
}

.filter-bar {
  box-sizing: border-box;
  width: 100%;
  height: 56/20rem;
  padding: 10/20rem 20/20rem;
  background: #ffffff;
  z-index: 999;
}

.customer-list-wrapper {
  flex: 1;
  width: 100%;
  // height: 0;
  padding-top: 4/20rem;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 0;
}
</style>
